"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const domain_1 = require("@oolio-group/domain");
const utils_1 = require("../utils");
function default_1(event, prevState = {}) {
    const order = prevState;
    const tables = (0, utils_1.getTablesFromOrder)(order);
    const updatedTables = tables.map(table => ({
        ...table,
        status: domain_1.TableStatus.OCCUPIED,
    }));
    order.tables = updatedTables;
    order.table = updatedTables[0];
    return order;
}
exports.default = default_1;
//# sourceMappingURL=tableCheck.js.map